import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from "@angular/common";
import { FiltersActiveListComponent } from './filters-active-list.component';
import { MaterialModule } from '../../material/material.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@NgModule({
  imports: [
    NgCommonModule,
    MaterialModule,
    FlexLayoutModule
  ],
  exports: [FiltersActiveListComponent],
  declarations: [FiltersActiveListComponent]
})
export class FiltersActiveListModule { }
